import React, {
  Suspense,
} from 'react';

import ReactDOM
  from 'react-dom/client';

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';

import {
  Provider,
} from 'react-redux';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './index.css';

import App
  from './App';

import {
  store,
} from './app/store';

import {
  LanguageProvider,
} from './context/LanguageContext';

import {
  FeatureForCamelCase as PostsFeature,
  fetchers as postsFetchers,
} from './features/posts/postsSlice';

import {
  fetchHomes,
  fetchMainHomes,
  fetchPilar1Homes,
  fetchPilar2Homes,
  fetchPilar3Homes,
  fetchAnnouncesHomes,
} from './features/homes/homesSlice';

import {
  fetchUsers,
  fetchParticipants,
  fetchSponsors,
} from './features/users/usersSlice';


store.dispatch(fetchUsers());

store.dispatch(fetchParticipants());

store.dispatch(fetchSponsors());

store.dispatch(fetchHomes());

store.dispatch(fetchMainHomes());

store.dispatch(fetchPilar1Homes());

store.dispatch(fetchPilar2Homes());

store.dispatch(fetchPilar3Homes());

store.dispatch(fetchAnnouncesHomes());

store.dispatch(
  postsFetchers[
    `fetch${PostsFeature}`
  ]()
);


ReactDOM
  .createRoot(
    document.getElementById('root')
  )
  .render(
    <React.StrictMode>
      <Suspense
        fallback={
          <span>
            Loading...
          </span>
        }
      >
        <Provider store={store}>
          <LanguageProvider>
            <Router>
              <Routes>
                <Route
                  path="/*"
                  element={<App />}
                />
              </Routes>
            </Router>
          </LanguageProvider>
        </Provider>
      </Suspense>
    </React.StrictMode>
  );
